import {create} from 'zustand';
import {UsePortalRedirectLinkStoreProps} from './types';

export const usePortalRedirectLinkStore = create<UsePortalRedirectLinkStoreProps>(set => ({
	portalRedirectLink: '',
	setPortalRedirectLink: portal => set({portalRedirectLink: portal}),
	resetPortalRedirectLink: () => set({portalRedirectLink: ''}),
}));
